import ApplicationAdapter from 'register-partners-js/adapters/application';

export default class RedirectionTokenAdapter extends ApplicationAdapter {
  urlForFindRecord(id) {
    return `${this.host}/${this.namespace}/redirection_tokens/${id}`;
  }
}
